<template>
  <div>
    <h1 class="text-2xl leading-tight font-bold mt-50 xl:mt-100">
      {{ product.title }}
    </h1>
    <p
      v-if="product.variants[0]?.title"
      class="lowercase"
    >
      {{ product.variants[0].title }}
    </p>
    <p
      v-if="product.logicTradeConfigurable"
      class="mt-5 mb-10"
    >
      <product-price :product="product" />
    </p>
    <p
      v-else-if="defaultVariant?.sales?.length"
      class="mt-5 mb-10"
    >
      <span class="text-red-500">
        {{ formatCurrency(defaultVariant.salePrice) }}&nbsp;
      </span>
      <span class="line-through">
        {{ formatCurrency(defaultVariant.price) }}
      </span>
    </p>
    <p
      v-else
      class="mt-5 mb-10"
    >
      {{ product.defaultPriceAsCurrency }}
    </p>
  </div>
</template>

<script setup>
import { computed, formatCurrency } from '#imports';

// Props
const { product } = defineProps({
  product: {
    type: Object,
    required: true,
  },
});

// Computed properties
const defaultVariant = computed(() => product.variants.find((variant) => variant.isDefault));
</script>
